import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import IconButton from 'Common/Components/IconButton';
import { Edit } from '../../styled';
import ModalWarning from 'Common/Components/ModalWarning';
import { getVulnId } from 'Common/Functions/vulnerabilityId';

const EditButton = ({ hasVulns, vulnsSelected, openVulnDetail }) => {
  const [showWarning, setShowWarning] = useState(false);
  const intl = useIntl();
  const message = intl.formatMessage({ id: 'modalWarning.selectOnlyOne' }, { entity: 'vulnerability' });
  const handleClick = () => {
    if (hasVulns) {
      if (vulnsSelected.length === 1) openVulnDetail(getVulnId(vulnsSelected[0]));
      else setShowWarning(true);
    }
  };

  const onClose = () => setShowWarning(false);

  return (
    <>
      <IconButton icon={ <Edit /> } title="Edit" onClick={ handleClick } disabled={ !hasVulns } />
      { showWarning && <ModalWarning onCloseCallback={ onClose } title="Edit" description={ message } /> }
    </>
  );
};

export default EditButton;
